import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, useState } from "react";
import CloseIcon from "assets/icons/close.svg?react";
import ElementIcon from "assets/icons/el.svg?react";
import { animated, useSpring } from "@react-spring/web";
import { Props } from "./typings";

const SidebarNotExpandedFilters: FC<Props> = ({
  handleNavigate,
  filters,
  filterName,
  setShowFilters,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  const stylesAnim = useSpring({
    from: {
      left: isClosing ? 0 : -700,
    },
    to: {
      left: isClosing ? -700 : 0,
    },
    onRest: () => {
      if (isClosing) {
        setShowFilters(false);
      }
    },
  });

  const handleClose = () => {
    setIsClosing(true);
  };

  return ReactDOM.createPortal(
    <animated.div className={styles.wrapper} style={stylesAnim}>
      <div className={styles.margin}>
        <div className={styles.title}>
          <div className={styles.name}>{filterName}</div>
          <CloseIcon onClick={handleClose} />
        </div>
        <div className={styles.list}>
          {filters.map((filter) => (
            <div
              key={filter.Id}
              onClick={() => {
                handleNavigate(filter.Id, filter?.isIncoming ?? true);
                handleClose();
              }}
              className={styles.box}
            >
              <ElementIcon /> {filter.Name}
            </div>
          ))}
        </div>
      </div>
    </animated.div>,
    document.body
  );
};

export default SidebarNotExpandedFilters;
